import React from "react";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { withTranslation } from "../../i18n";
import TestimonyDesktop from "./TestimonyDesktop";
import TestimonyMobile from "./TestimonyMobile";

const Testimony = ({ t }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <>
            {isMobile ? <TestimonyMobile t={t} /> : <TestimonyDesktop t={t} />}
        </>
    );
};

export default withTranslation(["myfitsociety"])(Testimony);